import React, { useState } from 'react';
import bgImage from '../../../assets/images/bg_img.svg';
import aboutImage from '../../../assets/images/inner_design_heading.svg';
import successImg from '../../../assets/images/success_icon.svg';
import { BecomePartnerAndContactService } from '../../../services/BecomePartnerAndContactService';
import { STATUS_SUCCESS } from '../../../utils/constants';
import BecomePartnerPageHelmet from '../../HelmetComponents/BecomePartnerPageHelmet';
import evalutionIcon from '../../../assets/images/evalution_icon.svg';
import inquiryIcon from '../../../assets/images/inquiry_icon.svg';
import trainingIcon from '../../../assets/images/training_icon.svg';
import handShakeIcon from '../../../assets/images/hand_shake_icon.svg';
import growthIcon from '../../../assets/images/growth_icon.svg';

type FormData = {
  name: string;
  email: string;
  phone: string;
  businessName: string;
  businessType: string;
  distributionArea: string;
  hasVehicle: string;
  comment: string;
  operatingSince: string;
  businessAdress: string;
};

type Errors = Partial<Record<keyof FormData, string>>;

const BecomePartner: React.FC = () => {
  // useDocumentTitle('Become Partner');
  const [formData, setFormData] = useState<FormData>({
    name: '',
    email: '',
    phone: '',
    businessName: '',
    businessType: '',
    distributionArea: '',
    hasVehicle: '',
    comment: '',
    operatingSince: '',
    businessAdress: '',
  });

  const [errors, setErrors] = useState<Errors>({});
  const [loading, setLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));

    // Clear error on change
    setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const validate = (): boolean => {
    const newErrors: Errors = {};
    /** Name required */
    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
    }

    /**Phone required   */
    if (!formData.phone.trim()) {
      newErrors.phone = 'Phone is required';
    } else if (!/^\d+$/.test(formData.phone)) {
      newErrors.phone = 'Mobile number must be a number';
    } else if (formData.phone.length !== 10) {
      newErrors.phone = 'Phone must be exactly 10 digits';
    } else if (!/^[6-9]\d{9}$/.test(formData.phone)) {
      newErrors.phone = 'Enter a valid 10-digit Indian mobile number';
    }

    /** Email required and must be valid format */
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Invalid email format';
    }

    /** businessName required */
    if (!formData.businessName.trim()) {
      newErrors.businessName = 'Business Name is required';
    }

    if (!formData.businessType.trim()) {
      newErrors.businessType = 'Business Type Name is required';
    }

    if (!formData.distributionArea.trim()) {
      newErrors.distributionArea = 'Distribution Area is required';
    }

    if (!formData.hasVehicle.trim()) {
      newErrors.hasVehicle = 'Please Select Vehicle For Distribution';
    }

    if (!formData.operatingSince.trim()) {
      newErrors.operatingSince = 'Operating Your Business is required';
    }

    if (!formData.businessAdress.trim()) {
      newErrors.businessAdress = 'Business Adress is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      const payload = {
        company: null,
        phone: formData.phone,
        email: formData.email,
        comment: formData.comment,
        inquiry_type: 'distributor',
        website_name: null,
        business_name: formData.businessName,
        current_business_type: formData.businessType,
        how_long_have_you_been_oprating_your_business: formData.operatingSince,
        do_you_currently_have_your_own_vehicle_for_distribution: formData.hasVehicle,
        preferred_area_of_distribution: formData.distributionArea,
        business_address: formData.businessAdress,
      };
      // console.log('payload', payload)
      const response = await BecomePartnerAndContactService.BecomePartnerAndContactSendData(payload);
      const apiResp = response.message;
      if (apiResp.status === STATUS_SUCCESS) {
        setFormData({
          name: '',
          email: '',
          phone: '',
          businessName: '',
          businessType: '',
          distributionArea: '',
          hasVehicle: '',
          comment: '',
          operatingSince: '',
          businessAdress: '',
        });
        setLoading(false);
        setShowSuccessModal(true);
      } else {
        setLoading(false);
      }
    } catch (error: any) {
      setLoading(false);
    }
  };

  return (
    <>
      <BecomePartnerPageHelmet />
      <section className='w-full'>
        <div
          className='relative flex flex-col items-center justify-center h-[300px] sm:h-[300px] md:h-[600px] text-center'
          style={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <h1 className='font-rubik text-[28px] sm:text-[28px] md:text-[32px] lg:text-[32px] text-[#4A2D1A] font-bold relative md:mt-4 lg:mt-4 drop-shadow-[0_2px_2px_rgba(0,0,0,0.7)]'>
            BECOME PARTNER
          </h1>
          <div className='flex justify-center mt-4 w-full px-4'>
            <img src={aboutImage} alt='Become partner Icon' className='max-w-full h-auto' />
          </div>
        </div>
        {/* --- Become a Partner with Namasteji Manikchand --- */}
        <section className='py-6 sm:py-6 md:py-14 lg:py-14 px-4 sm:px-8 md:px-16 text-center bg-white'>
          <h2 className='font-rubik text-[26px] sm:text-[26px] md:text-[32px] lg:text-[32px] font-bold text-[#4A2D1A]'>
            BECOME A PARTNER WITH NAMASTEJI MANIKCHAND
          </h2>
          <div className='flex justify-center mb-2 sm:mb-2 md:mb-6 lg:mb-6'>
            <img
              src={aboutImage}
              alt='Packaging Manikchand'
              className='max-w-[90%] sm:max-w-[90%] md:max-w-[40%] lg:max-w-[40%] h-auto'
            />
          </div>
          <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto text-black leading-relaxed text-justify'>
            Welcome to the partner opportunity page for Namasteji Manikchand. If you’re looking to align with a
            distinguished brand in the pan masala industry, you’ve come to the right place. We invite ambitious
            retailers, distributors and business-entrepreneurs to partner with us, leverage our brand strength and
            access a robust business model backed by premium quality products, trusted reputation and efficient
            supply-chain support.
          </p>
          <br />
          <p className='max-w-6xl mx-auto pb-2 font-rubik text-[22px] sm:text-[22px] md:text-[26px] lg:text-[26px] font-bold text-[#4A2D1A] text-start'>
            What We Offer Our Partners
          </p>
          <ol
            className='max-w-6xl mx-auto list-disc space-y-1 sm:space-y-1 md:space-y-2 lg:space-y-2 pl-5 pt-4 sm:pt-6 font-poppins text-sm sm:text-sm md:text-lg lg:text-lg text-black leading-relaxed text-justify'
            style={{
              borderTop: '2px solid',
              borderImageSource:
                'linear-gradient(90deg, #C79856 6.06%, #FAD983 27.27%, #DFB662 47.27%, #FAD983 72.53%, #B27F32 95.6%)',
              borderImageSlice: 1,
            }}
          >
            <li className='text-justify'>
              <strong>Heritage of Taste</strong>: Decades of expertise in crafting pan masala blends that reflect
              India’s rich flavor traditions.
            </li>
            <li className='text-justify'>
              <strong>Premium Ingredients</strong>: Only quality raw materials and strict quality assurance, ensuring
              every morsel meets high standards.
            </li>
            <li className='text-justify'>
              <strong>Modern Manufacturing</strong>: State-of-the-art facilities, hygienic production, and efficient
              logistics to maintain freshness and consistency.
            </li>
            <li className='text-justify'>
              <strong>Trusted Brand</strong>: A brand that retailers, distributors and end-users alike rely upon for
              taste, quality and service.
            </li>
            <li className='text-justify'>
              <strong>Innovative Range</strong>: A variety of flavor profiles, packaging formats and offerings designed
              for evolving consumer tastes.
            </li>
          </ol>
        </section>

        {/* WHY PARTNER WITH US */}
        <section className='py-6 sm:py-6 md:py-14 lg:py-14 px-4 sm:px-8 md:px-16 text-center bg-[#F8F8F8]'>
          <h2 className='font-rubik text-[26px] sm:text-[26px] md:text-[32px] lg:text-[32px] font-bold text-[#4A2D1A]'>
            WHY PARTNER WITH US
          </h2>
          <div className='flex justify-center mb-2 sm:mb-2 md:mb-6 lg:mb-6'>
            <img
              src={aboutImage}
              alt='Packaging Manikchand'
              className='max-w-[90%] sm:max-w-[90%] md:max-w-[40%] lg:max-w-[40%] h-auto'
            />
          </div>
          <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto text-black leading-relaxed text-justify'>
            Namasteji Manikchand stands for heritage, consistency and quality. By partnering with us, you become part of
            a legacy that consumers recognise and trust. Our commitment to innovation, strong consumer demand and
            streamlined distribution systems mean our partners can enjoy healthy margins, brand cooperation and growth
            potential. Whether you are already in the trade or exploring new business avenues, we provide the tools,
            training and support to succeed.
          </p>
        </section>

        {/* Steps to Become Our Partner */}
        <section className='max-w-7xl mx-auto px-4 sm:px-4 md:px-14 lg:px-14 py-6 md:py-14 lg:py-14 gap-6 bg-white'>
          <h2 className='font-rubik text-[26px] sm:text-[26px] md:text-[32px] lg:text-[32px] font-bold text-[#4A2D1A] text-center'>
            STEP TO BECOME OUR PARTNER
          </h2>
          <div className='flex justify-center mb-2 sm:mb-2 md:mb-6 lg:mb-6'>
            <img
              src={aboutImage}
              alt='Packaging Manikchand'
              className='max-w-[90%] sm:max-w-[90%] md:max-w-[47%] lg:max-w-[47%] h-auto'
            />
          </div>

          {/* Desktop View */}
          <div className='hidden md:block'>
            <div className='space-y-6'>
              {/* Step 1 */}
              <div className='grid grid-cols-1 md:grid-cols-12 gap-6'>
                <div className='col-span-12 md:col-span-7 border border-[#4A2D1A] rounded-xl items-center px-4 py-2 gap-4 transition-all duration-300 hover:shadow-md'>
                  <div className='grid grid-cols-1 md:grid-cols-6 items-center gap-4'>
                    <div className='col-span-1 md:col-span-5'>
                      <h3 className='font-rubik text-[24px] font-medium text-[#4A2D1A] pb-1'>
                        1. Inquiry & Application
                      </h3>
                      <p className='font-poppins text-black text-base leading-relaxed'>
                        Fill out our partnership interest form or contact our trade-team to discuss your market,
                        capacity and goals.
                      </p>
                    </div>
                    <div className='flex justify-end'>
                      <img
                        src={inquiryIcon}
                        alt='Inquiry Icon'
                        className='w-28 h-28 object-contain transition-transform duration-300 hover:scale-105'
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className='grid grid-cols-1 md:grid-cols-12 gap-6'>
                <div className='col-span-12 md:col-span-5 items-center px-4 py-2 gap-4 transition-all duration-300 hover:shadow-md'></div>
                <div className='col-span-12 md:col-span-7 border border-[#4A2D1A] rounded-xl items-center px-4 py-2 gap-4 transition-all duration-300 hover:shadow-md'>
                  <div className='grid grid-cols-1 md:grid-cols-6 items-center gap-4'>
                    <div className='col-span-1 md:col-span-5'>
                      <h3 className='font-rubik text-[24px] font-medium text-[#4A2D1A] pb-1'>
                        2. Evaluation & Onboarding
                      </h3>
                      <p className='font-poppins text-black text-base leading-relaxed'>
                        Our team assesses your profile, explains business terms, territory details, margin structures
                        and support mechanisms.
                      </p>
                    </div>
                    <div className='flex justify-center md:justify-end'>
                      <img
                        src={evalutionIcon}
                        alt='Evalution Icon'
                        className='w-28 h-28 object-contain transition-transform duration-300 hover:scale-105'
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className='grid grid-cols-1 md:grid-cols-12 gap-6'>
                <div className='col-span-12 md:col-span-7 border border-[#4A2D1A] rounded-xl items-center px-4 py-2 gap-4 transition-all duration-300 hover:shadow-md'>
                  <div className='grid grid-cols-1 md:grid-cols-6 items-center gap-4'>
                    <div className='col-span-1 md:col-span-5'>
                      <h3 className='font-rubik text-[24px] font-medium text-[#4A2D1A] pb-1'>3. Training & Launch</h3>
                      <p className='font-poppins text-black text-base leading-relaxed'>
                        Once approved, you receive product training, brand guidelines, merchandising materials and
                        initial stock support.
                      </p>
                    </div>
                    <div className='flex justify-end'>
                      <img
                        src={trainingIcon}
                        alt='Training Icon'
                        className='w-28 h-28 object-contain transition-transform duration-300 hover:scale-105'
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className='grid grid-cols-1 md:grid-cols-12 gap-6'>
                <div className='col-span-12 md:col-span-5 items-center px-4 py-2 gap-4 transition-all duration-300 hover:shadow-md'></div>
                <div className='col-span-12 md:col-span-7 border border-[#4A2D1A] rounded-xl items-center px-4 py-2 gap-4 transition-all duration-300 hover:shadow-md'>
                  <div className='grid grid-cols-1 md:grid-cols-6 items-center gap-4'>
                    <div className='col-span-1 md:col-span-5'>
                      <h3 className='font-rubik text-[24px] font-medium text-[#4A2D1A] pb-1'>4. Go-Live & Support</h3>
                      <p className='font-poppins text-black text-base leading-relaxed'>
                        Begin operations with full support marketing materials, promotions, regular supply, performance
                        tracking, and brand updates.
                      </p>
                    </div>
                    <div className='flex justify-center md:justify-end'>
                      <img
                        src={handShakeIcon}
                        alt='Support Icon'
                        className='w-28 h-28 object-contain transition-transform duration-300 hover:scale-105'
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className='grid grid-cols-1 md:grid-cols-12 gap-6'>
                <div className='col-span-12 md:col-span-7 border border-[#4A2D1A] rounded-xl items-center px-4 py-2 gap-4 transition-all duration-300 hover:shadow-md'>
                  <div className='grid grid-cols-1 md:grid-cols-6 items-center gap-4'>
                    <div className='col-span-1 md:col-span-5'>
                      <h3 className='font-rubik text-[24px] font-medium text-[#4A2D1A] pb-1'>5. Growth & Expansion</h3>
                      <p className='font-poppins text-black text-base leading-relaxed'>
                        As business grows, we offer advanced products, exclusive rights, higher stock, and co-marketing
                        opportunities.
                      </p>
                    </div>
                    <div className='flex justify-end'>
                      <img
                        src={growthIcon}
                        alt='Growth Icon'
                        className='w-28 h-28 object-contain transition-transform duration-300 hover:scale-105'
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Moobile View */}
          <div className='block sm:block md:hidden lg:hidden space-y-4'>
            <div className='rounded-xl bg-white mb-4 p-3 hover:shadow-lg transition-all duration-300 border border-[#4A2D1A]'>
              <div
                className='reward-how-to-work-card'
                style={{ '--reward-how-to-work-bg': `url(${inquiryIcon})` } as React.CSSProperties}
              >
                <h3 className='font-rubik text-[18px] font-medium text-[#4A2D1A] py-1'>1. Inquiry & Application</h3>
                <p className='font-poppins text-black text-xs leading-relaxed text-justify py-2'>
                  Fill out our partnership interest form or contact our trade-team to discuss your market, capacity and
                  goals.
                </p>
              </div>
            </div>

            <div className='rounded-xl bg-white mb-4 p-3 hover:shadow-lg transition-all duration-300 border border-[#4A2D1A]'>
              <div
                className='reward-how-to-work-card'
                style={{ '--reward-how-to-work-bg': `url(${evalutionIcon})` } as React.CSSProperties}
              >
                <h3 className='font-rubik text-[18px] font-medium text-[#4A2D1A] py-1'>2. Evaluation & Onboarding</h3>
                <p className='font-poppins text-black text-xs leading-relaxed text-justify py-2'>
                  Our team assesses your profile, explains business terms, territory details, margin structures and
                  support mechanisms.
                </p>
              </div>
            </div>

            <div className='rounded-xl bg-white mb-4 p-3 hover:shadow-lg transition-all duration-300 border border-[#4A2D1A]'>
              <div
                className='reward-how-to-work-card'
                style={{ '--reward-how-to-work-bg': `url(${trainingIcon})` } as React.CSSProperties}
              >
                <h3 className='font-rubik text-[18px] font-medium text-[#4A2D1A] py-1'>3. Training & Launch</h3>
                <p className='font-poppins text-black text-xs leading-relaxed text-justify py-2'>
                  Once approved, you receive product training, brand guidelines, merchandising materials and initial
                  stock support.
                </p>
              </div>
            </div>

            <div className='rounded-xl bg-white mb-4 p-3 hover:shadow-lg transition-all duration-300 border border-[#4A2D1A]'>
              <div
                className='reward-how-to-work-card'
                style={{ '--reward-how-to-work-bg': `url(${handShakeIcon})` } as React.CSSProperties}
              >
                <h3 className='font-rubik text-[18px] font-medium text-[#4A2D1A] py-1'>4. Go-Live & Support</h3>
                <p className='font-poppins text-black text-xs leading-relaxed text-justify py-2'>
                  Begin operations with full support marketing materials, promotions, regular supply, performance
                  tracking, and brand updates.
                </p>
              </div>
            </div>

            <div className='rounded-xl bg-white mb-4 p-3 hover:shadow-lg transition-all duration-300 border border-[#4A2D1A]'>
              <div
                className='reward-how-to-work-card'
                style={{ '--reward-how-to-work-bg': `url(${growthIcon})` } as React.CSSProperties}
              >
                <h3 className='font-rubik text-[18px] font-medium text-[#4A2D1A] py-1'>5. Growth & Expansion</h3>
                <p className='font-poppins text-black text-xs leading-relaxed text-justify py-2'>
                  As business grows, we offer advanced products, exclusive rights, higher stock, and co-marketing
                  opportunities.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* --- Why Now Is The Right Time --- */}
        <section className='py-6 sm:py-6 md:py-14 lg:py-14 px-4 sm:px-8 md:px-16 text-center bg-[#F8F8F8]'>
          <h2 className='font-rubik text-[26px] sm:text-[26px] md:text-[32px] lg:text-[32px] font-bold text-[#4A2D1A]'>
            WHY NOW IS THE RIGHT TIME
          </h2>
          <div className='flex justify-center mb-2 sm:mb-2 md:mb-6 lg:mb-6'>
            <img
              src={aboutImage}
              alt='Packaging Manikchand'
              className='max-w-[90%] sm:max-w-[90%] md:max-w-[40%] lg:max-w-[40%] h-auto'
            />
          </div>
          <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto text-black leading-relaxed text-justify'>
            The Indian pan masala market remains vibrant, driven by a large consumer base, multiple regional preferences
            and brand loyalty dynamics. By partnering now with Namasteji Manikchand, you tap into a rising demand,
            benefit from a mature business model and align with a brand that’s ready to grow. With the right effort and
            our support, you can achieve significant growth in your region.
          </p>
          <br />
          <p
            className='max-w-6xl mx-auto pb-2 font-rubik text-[22px] sm:text-[22px] md:text-[26px] lg:text-[26px] font-bold text-[#4A2D1A] text-start'
            style={{
              borderBottom: '2px solid',
              borderImageSource:
                'linear-gradient(90deg, #C79856 6.06%, #FAD983 27.27%, #DFB662 47.27%, #FAD983 72.53%, #B27F32 95.6%)',
              borderImageSlice: 1,
            }}
          >
            Our Commitment to You
          </p>
          <p className='max-w-6xl mx-auto py-2 text-sm sm:text-sm md:text-lg lg:text-lg text-black text-start font-medium font-poppins'>
            At Namasteji Manikchand, we don’t just sign partners — we build relationships. We commit to:
          </p>

          <ol className='max-w-6xl pl-6 mx-auto list-disc space-y-1 sm:space-y-1 md:space-y-2 lg:space-y-2 font-poppins text-sm sm:text-sm md:text-lg lg:text-lg text-black leading-relaxed text-justify'>
            <li className='text-justify'>Transparent business terms and clear margin structures.</li>
            <li className='text-justify'>Timely communication, supply reliability and territory protection.</li>
            <li className='text-justify'>Regular product innovation, packaging upgrades and brand refreshes.</li>
            <li className='text-justify'>Marketing investments and trade-promotions to aid your growth.</li>
            <li className='text-justify'>
              Training, feedback loops and performance reviews to optimize results together.
            </li>
          </ol>
        </section>

        {/* --- BECOME PARTNER Form --- */}
        <section className='py-2 sm:py-2 md:py-14 lg:py-14 px-4 sm:px-8 md:px-16 text-center bg-white'>
          <div className='max-w-6xl mx-auto bg-white bg-opacity-90 rounded-lg'>
            {/* <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-3xl font-bold text-[#4A2D1A] mt-6 sm:mt-6 md:mt-0 lg:mt-0  mb-4 md:mb-6 lg:mb-6 sm:mb-6">
            BECOME PARTNER
          </h2> */}
            <h2 className='font-rubik text-[26px] sm:text-[26px] md:text-[32px] lg:text-[32px] font-bold text-[#4A2D1A]'>
              READY TO PARTNER?
            </h2>
            <div className='flex justify-center mb-2 sm:mb-2 md:mb-6 lg:mb-6'>
              <img
                src={aboutImage}
                alt='Packaging Manikchand'
                className='max-w-[90%] sm:max-w-[90%] md:max-w-[45%] lg:max-w-[45%] h-auto'
              />
            </div>
            <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto text-black leading-relaxed text-justify'>
              If you believe you have the drive, infrastructure and market understanding to grow with us, we’d love to
              hear from you. Join the Namasteji Manikchand partner network and embark on a profitable journey of
              business expansion with one of India’s trusted pan masala brands.
              <br /> Thank you for considering Namasteji Manikchand as your business partner. Together, we’ll build
              success in every pouch, every outlet and every region.
            </p>
            <br />
            <br />
            <form
              onSubmit={handleSubmit}
              className='grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-3 md:gap-6 lg:gap-6 text-left text-base'
            >
              {/* Name */}
              <div className='sm:col-span-2'>
                <label className='block mb-2 font-poppins text-base'>
                  Name<span className='text-red-600'>*</span>
                </label>
                <input
                  type='text'
                  name='name'
                  className={`w-full border border-[#c6c0c0]  rounded-lg px-4 py-1 sm:py-1 md:py-2 lg:py-2 ${
                    errors.name ? 'border-red-500' : ''
                  }`}
                  value={formData.name}
                  onChange={handleChange}
                />
                {errors.name && <p className='text-red-500 text-sm mt-1'>{errors.name}</p>}
              </div>

              {/* Phone */}
              <div>
                <label className='block mb-1 font-poppins text-base'>
                  Phone Number<span className='text-red-600'>*</span>
                </label>
                <input
                  type='text'
                  name='phone'
                  maxLength={10}
                  className={`w-full border border-[#c6c0c0] rounded-lg px-4 py-1 sm:py-1 md:py-2 lg:py-2 ${
                    errors.phone ? 'border-red-500' : ''
                  }`}
                  value={formData.phone}
                  onChange={handleChange}
                />
                {errors.phone && <p className='text-red-500 text-sm mt-1'>{errors.phone}</p>}
              </div>

              {/* Email */}
              <div>
                <label className='block mb-1 font-poppins text-base'>
                  Email<span className='text-red-600'>*</span>
                </label>
                <input
                  type='email'
                  name='email'
                  className={`w-full border border-[#c6c0c0] rounded-lg px-4 py-1 sm:py-1 md:py-2 lg:py-2 ${
                    errors.email ? 'border-red-500' : ''
                  }`}
                  value={formData.email}
                  onChange={handleChange}
                />
                {errors.email && <p className='text-red-500 text-sm mt-1'>{errors.email}</p>}
              </div>

              {/* Business Name */}
              <div>
                <label className='block mb-1 font-poppins text-base'>
                  Business Name<span className='text-red-600'>*</span>
                </label>
                <input
                  type='text'
                  name='businessName'
                  className={`w-full border border-[#c6c0c0] rounded-lg px-4 py-1 sm:py-1 md:py-2 lg:py-2 ${
                    errors.businessName ? 'border-red-500' : ''
                  }`}
                  value={formData.businessName}
                  onChange={handleChange}
                />
                {errors.businessName && <p className='text-red-500 text-sm mt-1'>{errors.businessName}</p>}
              </div>
              {/* Business ADDRESS */}
              <div>
                <label className='block mb-1 font-poppins text-base'>
                  Business Address<span className='text-red-600'>*</span>
                </label>
                <input
                  type='text'
                  name='businessAdress'
                  className={`w-full border border-[#c6c0c0] rounded-lg px-4 py-1 sm:py-1 md:py-2 lg:py-2 ${
                    errors.businessAdress ? 'border-red-500' : ''
                  }`}
                  value={formData.businessAdress}
                  onChange={handleChange}
                />
                {errors.businessAdress && <p className='text-red-500 text-sm mt-1'>{errors.businessAdress}</p>}
              </div>
              {/* Distribution Area */}
              <div>
                <label className='block mb-1 font-poppins text-base'>
                  Preferred Area of Distribution
                  <span className='text-red-600'>*</span>
                </label>
                <input
                  type='text'
                  name='distributionArea'
                  className={`w-full border border-[#c6c0c0] rounded-lg px-4 py-1 sm:py-1 md:py-2 lg:py-2 ${
                    errors.distributionArea ? 'border-red-500' : ''
                  }`}
                  value={formData.distributionArea}
                  onChange={handleChange}
                />

                {errors.distributionArea && <p className='text-red-500 text-sm mt-1'>{errors.distributionArea}</p>}
              </div>
              {/* Business Type  */}
              <div>
                <label className='block mb-1 font-poppins text-base'>
                  Current Business Type<span className='text-red-600'>*</span>
                </label>
                <input
                  type='text'
                  name='businessType'
                  className={`w-full border border-[#c6c0c0] rounded-lg px-4 py-1 sm:py-1 md:py-2 lg:py-2 ${
                    errors.businessType ? 'border-red-500' : ''
                  }`}
                  value={formData.businessType}
                  onChange={handleChange}
                />
                {errors.businessType && <p className='text-red-500 text-sm mt-1'>{errors.businessType}</p>}
              </div>

              {/* Vehicle */}
              <div className='sm:col-span-2'>
                <label className='block mb-1 font-poppins text-base'>
                  Do you currently have your own vehicle for distribution?
                  <span className='text-red-600'>*</span>
                </label>
                <select
                  name='hasVehicle'
                  className={`w-full bg-white border border-[#c6c0c0] rounded-lg px-4 py-2 sm:py-2 md:py-2 lg:py-2 ${
                    errors.hasVehicle ? 'border-red-500' : ''
                  }`}
                  value={formData.hasVehicle}
                  onChange={handleChange}
                >
                  <option value='' disabled>
                    Select
                  </option>
                  <option value='Yes'>Yes</option>
                  <option value='No'>No</option>
                </select>
                {errors.hasVehicle && <p className='text-red-500 text-sm mt-1'>{errors.hasVehicle}</p>}
              </div>

              <div className='sm:col-span-2'>
                <label className='block mb-2 font-poppins text-base'>
                  How long have you been operating your business?
                  <span className='text-red-600'>*</span>
                </label>
                <input
                  type='text'
                  name='operatingSince'
                  value={formData.operatingSince}
                  onChange={handleChange}
                  className={`w-full border border-[#c6c0c0] rounded-lg px-4 py-1 sm:py-1 md:py-2 lg:py-2 ${
                    errors.operatingSince ? 'border-red-500' : ''
                  }`}
                />
                {errors.operatingSince && <p className='text-red-500 text-sm mt-1'>{errors.operatingSince}</p>}
              </div>

              {/* Comment (Optional) */}
              <div className='sm:col-span-2'>
                <label className='block mb-1 font-poppins text-base'>Comment</label>
                <textarea
                  name='comment'
                  rows={3}
                  className='w-full border border-[#c6c0c0] rounded-lg px-4 py-1 sm:py-1 md:py-2 lg:py-2'
                  value={formData.comment}
                  onChange={handleChange}
                />
              </div>

              {/* Submit Button */}
              <div className='sm:col-span-2 flex  justify-top -mt-1 sm:-mt-1 md:mt-0 lg:mt-0 mb-4 sm:mb-4 md:mb-0 lg:mb-0'>
                <button
                  type='submit'
                  className='px-8 sm:px-12 py-2 sm:py-2 md:py-3 lg:py-3 bg-red-700 text-white rounded-xl hover:bg-red-800 transition font-semibold font-poppins'
                  disabled={loading}
                >
                  &nbsp;&nbsp;&nbsp;{loading ? 'Sending...' : 'Send'}
                  &nbsp;&nbsp;&nbsp;
                </button>
              </div>
            </form>
          </div>
        </section>

        {/* SUCCESS MODAL */}
        {showSuccessModal && (
          <div className='fixed inset-2 flex items-center justify-center z-50 bg-black bg-opacity-50'>
            <div className='bg-white rounded-xl shadow-xl max-w-xs sm:max-w-xs md:max-w-lg lg:max-w-lg w-full p-3 text-center '>
              <h2 className='font-rubik text-[22px] sm:text-[22px] md:text-[30px] lg:text-[30px] font-bold text-[#4A2D1A] mb-0 sm:mb-0 md:mb-2 lg:mb-2'>
                Thank you for reaching out to Namasteji Manikchand!
              </h2>
              <img src={successImg} alt='Success' className='mx-auto size-24 sm:size-24 md:size-36 lg:size-36' />
              <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg text-gray-800 mb-4'>
                We have received your inquiry and one of our executives will contact you within the next 2 business days
              </p>
              <button
                onClick={() => setShowSuccessModal(false)}
                className='font-poppins bg-red-700 text-white py-2 px-6 rounded-xl hover:bg-red-800 transition font-semibold'
              >
                <strong>OK</strong>
              </button>
            </div>
          </div>
        )}
      </section>
    </>
  );
};
export default BecomePartner;
